import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// ProfileTourCard.tsx — Single-step profile collection card with progress ring.
import { useState } from "react";
import { ProgressRing } from "../ui/ProgressRing";
import { CardFieldRenderer } from "./CardFieldRenderer";
export function ProfileTourCard({ card, onSubmit, onSkip }) {
    const [values, setValues] = useState({});
    const [submitting, setSubmitting] = useState(false);
    const [saved, setSaved] = useState(false);
    const field = card.fields[0];
    const progress = card.progress;
    const pct = progress
        ? Math.round(progress.completeness_before * 100)
        : null;
    const handleChange = (key, val) => setValues((v) => ({ ...v, [key]: val }));
    const handleSave = async () => {
        if (!field)
            return;
        const answer = values[field.key];
        if (answer === undefined || answer === null || answer === "")
            return;
        setSubmitting(true);
        try {
            await onSubmit(card.card_id, card.card_type, {
                step_key: card.context?.step_key ?? field.key,
                [field.key]: answer,
            });
            setSaved(true);
        }
        finally {
            setSubmitting(false);
        }
    };
    if (saved) {
        return (_jsxs("div", { className: "mt-2 flex items-center gap-2 text-sm text-emerald-400 bg-slate-800/40 border border-slate-700/50 rounded-xl px-4 py-2.5", children: [_jsx("span", { children: "\u2713" }), _jsx("span", { children: "Saved" })] }));
    }
    return (_jsxs("div", { className: "mt-2 bg-slate-800/40 border border-slate-700/70 rounded-xl p-4 space-y-3 max-w-md", children: [_jsxs("div", { className: "flex items-center justify-between", children: [_jsx("span", { className: "text-xs text-slate-400 font-medium uppercase tracking-wide", children: card.subtitle ?? card.title }), pct !== null && (_jsxs("div", { className: "flex items-center gap-2", children: [_jsx(ProgressRing, { value: pct / 100, size: 28, strokeWidth: 3 }), _jsxs("span", { className: "text-xs text-slate-400", children: [pct, "%"] })] }))] }), field && (_jsxs("div", { className: "space-y-2", children: [_jsx("p", { className: "text-sm text-slate-200", children: field.label }), field.hint && (_jsx("p", { className: "text-xs text-slate-500", children: field.hint })), _jsx(CardFieldRenderer, { field: field, value: values[field.key], onChange: handleChange, disabled: submitting })] })), _jsxs("div", { className: "flex items-center gap-2 pt-1", children: [_jsx("button", { type: "button", onClick: handleSave, disabled: submitting || !field || (values[field.key] === undefined || values[field.key] === null || values[field.key] === ""), className: "px-3 py-1.5 rounded-lg bg-violet-600 hover:bg-violet-500 text-white text-sm font-medium disabled:opacity-40 transition-colors", children: submitting ? "Saving…" : "Save" }), _jsx("button", { type: "button", onClick: onSkip, disabled: submitting, className: "px-3 py-1.5 rounded-lg text-slate-400 hover:text-slate-200 text-sm transition-colors", children: "Skip for now" })] })] }));
}
